import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=20b87812"
import script from "./actions.js?vue&type=script&lang=js&external"
export * from "./actions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports